import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { SpecialDaysEditor } from './SpecialDaysEditor';

const DAYS = [['sun', 'Dom'], ['mon', 'Lun'], ['tue', 'Mar'], ['wed', 'Mié'], ['thu', 'Jue'], ['fri', 'Vie'], ['sat', 'Sáb']];

export const WaHoursSettings = ({ value, onChange, disabled }) => {
  if (!value) return null;
  const set = (patch) => onChange({ ...value, ...patch });
  const toggleDay = (d) => set({ days: value.days.includes(d) ? value.days.filter((x) => x !== d) : [...value.days, d] });
  const off = disabled || !value.enabled;

  return (
    <div className="py-4 border-b border-border space-y-4" data-testid="wa-hours-settings">
      <div className="flex items-center justify-between gap-6">
        <div>
          <div className="font-medium text-sm">Horario de atención por WhatsApp</div>
          <div className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">
            Fuera de horario el agente sigue respondiendo lo sencillo. Si no puede resolver algo, envía el aviso de abajo y deja el borrador para el equipo. La Suite sigue atendiendo 24/7.
          </div>
        </div>
        <Switch checked={value.enabled} disabled={disabled} onCheckedChange={(v) => set({ enabled: v })} data-testid="wa-hours-enabled" />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {DAYS.map(([d, l]) => (
          <button key={d} type="button" disabled={off} onClick={() => toggleDay(d)} data-testid={`wa-hours-day-${d}`}
            className={`px-3 py-1 rounded-full text-xs border transition-colors duration-150 disabled:opacity-50 ${value.days.includes(d) ? 'bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] border-transparent' : 'border-border text-[hsl(var(--muted-foreground))]'}`}>
            {l}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-3 text-xs">
        <label className="flex items-center gap-1.5">Abre
          <Input type="time" className="w-28" disabled={off} value={value.start} onChange={(e) => set({ start: e.target.value })} data-testid="wa-hours-start" />
        </label>
        <label className="flex items-center gap-1.5">Cierra
          <Input type="time" className="w-28" disabled={off} value={value.end} onChange={(e) => set({ end: e.target.value })} data-testid="wa-hours-end" />
        </label>
        <span className="text-[hsl(var(--muted-foreground))]">Hora de Venezuela (America/Caracas)</span>
      </div>
      <SpecialDaysEditor value={value.special || []} disabled={off} onChange={(special) => set({ special })} />
      <div className="space-y-1">
        <div className="text-xs font-medium">Aviso cuando el agente no puede responder fuera de horario</div>
        <Textarea rows={4} disabled={off} value={value.notice} onChange={(e) => set({ notice: e.target.value })} data-testid="wa-hours-notice" />
        <div className="text-[11px] text-[hsl(var(--muted-foreground))]">Usa <code>{'{horario}'}</code> para insertar el horario. En un día especial se agrega el motivo (por ejemplo, "Hoy no atendemos por: Vigilia nacional"). Se envía como máximo una vez por persona en cada periodo fuera de horario.</div>
      </div>
    </div>
  );
};
